import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod/v3'

const inboxSearchSchema = z.object({
  itemType: z.string().optional(),
  targetType: z.string().optional(),
  targetId: z.string().optional(),
  targetName: z.string().optional(),
  category: z.string().optional(),
  auditCycleId: z.string().optional(),
  // Deep-link target — highlights this auditor comment thread in the panel.
  commentId: z.string().optional(),
  // RFC-226 — which proposal on the selected AuditRequest to review inline.
  proposalKey: z.string().optional(),
  // Which list tab to land on. Omitted = Notifications by default (or
  // Requests when commentId is present — see InboxPage tab init).
  tab: z.enum(['notifications', 'requests']).optional(),
})

export const Route = createFileRoute(
  '/(protected)/workspaces/$workspaceId/inbox',
)({
  validateSearch: inboxSearchSchema,
  staticData: { pageHeader: { title: 'Inbox', pad: false, scroll: false } },
})
